<template>
  <div class="classifyNav">
    <div class="allclassify">
      <span class="iconfont icon-liebiao1"></span>
      <span style="margin-left:5px">{{isGaonS?isEnglish?"All Categories":"全部分类":"全部分类"}}</span>
    </div>
    <div class="content-a">
      <ul v-if="label.list.length!=16">
        <li
          v-for="(item,index) in label.list"
          :key="index"
          @click="toSearch(item)"
          class="categoryItem"
        >
          <div
            v-if="index<15"
          >{{isGaonS?(isEnglish&&((item.cname||'').indexOf('*##*')!=-1)?(item.cname||'').split('*##*')[1]:(item.cname||'').split('*##*')[0]):item.cname}}</div>
        </li>
        <li v-if="isshowmorebtn">
          <div
            @mouseover="mouseover"
            @mouseleave="mouseout"
          >{{isGaonS?isEnglish?"More...":"更多":"更多"}}</div>
          <div @mousemove="mouseover" @mouseleave="mouseout" class="moreinfodiv" v-if="isshowmore">
            <div
              v-for="(item,index) in moreclass"
              class="moreinfodiv-item"
              :key="index"
              @click="toSearch(item)"
            >{{isGaonS?(isEnglish&&((item.cname||'').indexOf('*##*')!=-1)?(item.cname||'').split('*##*')[1]:(item.cname||'').split('*##*')[0]):item.cname}}</div>
          </div>
        </li>
      </ul>

      <ul v-else>
        <li
          v-for="(item,index) in label.list"
          :key="index"
          @click="toSearch(item)"
          class="categoryItem"
        >
          <div>{{isGaonS?(isEnglish&&((item.cname||'').indexOf('*##*')!=-1)?(item.cname||'').split('*##*')[1]:(item.cname||'').split('*##*')[0]):item.cname}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      isshowmore: false,
      isshowmorebtn: false
    };
  },
  watch: {
    moreclass: {
      handler(val) {
        if (this.moreclass.length > 1) {
          this.isshowmorebtn = true;
        } else {
          this.isshowmorebtn = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters(["isGaonS", "isEnglish"]),
    moreclass() {
      if (this.label.list.length != 16) {
        var a = this.label.list.splice(15, this.label.list.length - 15);
        return a;
      } else {
        return this.label.list;
      }
    },
    labellist() {
      var a = this.label && this.label.list && this.label.list.length > 0;
      return a;
    }
  },
  props: {
    label: {
      type: Object,
      default() {
        return {
          id: "",
          list: []
        };
      }
    }
  },
  methods: {
    mouseover() {
      this.isshowmore = true;
    },
    mouseout() {
      this.isshowmore = false;
    },
    toSearch(item) {
      this.$router.push({
        path: "/search",
        query: { text: "", type: item.type, category_id: item.id }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.moreinfodiv {
  left: 178px;
  z-index: 999;
  bottom: 0px;

  background-color: white;
  position: absolute;
  display: flex;
  display: -webkit-flex;
  width: 600px;
  flex-wrap: wrap;
  .moreinfodiv-item {
    margin: 0px 10px;
    width: 90px;
    color: black;
  }
  .moreinfodiv-item:hover {
    background-color: red;
    color: white;
  }
}
.classifyNav {
  width: 180px;
  height: 100%;
  margin-right: 10px;
  position: relative;
  // background-color: pink;
  .allclassify {
    width: 100%;
    height: 56px;
    background-color: white;
    text-align: center;
    color: red;
    font-size: 16px;
    line-height: 56px;
    margin-bottom: 4px;
    vertical-align: middle;
    .allicon {
      margin-right: 14px;
      width: 20px;
      height: 17px;
      vertical-align: middle;
    }
  }
  .content-a {
    width: 100%;
    overflow: hidden;
    ul {
      width: 100%;
      overflow: hidden;
      li {
        cursor: pointer;
        width: 90px;
        height: 48px;
        float: left;
        box-sizing: border-box;
        border: 2px solid #f7f7f7;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        text-align: center;
        line-height: 50px;
        background-color: #ffffff;
      }
    }
    li:hover {
      background-color: red;
      color: white;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/classifyNav.vue